export default [
    {
        path: '/stats/dashboard',
        name: 'statistics',
        component: () => import('@/views/statistics/Dashboard.vue'),
    },
]
